import { OperationReportForm31Container } from "../../../containers/SupportSystem/OperationReportForm/OperationReportForm31Container"
export function OperationReportForm31Page () {
    return(
        <OperationReportForm31Container/>
    )
}